module.exports = __webpack_public_path__ + "static/img/personal-info.6674dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/subscription/personal-info.png
// module id = Qx9X
// module chunks = 6